import React, { useEffect, useState } from "react";
import styles from "./NewFooterUI.module.scss";
import unmeteredGif from "../../../assets/images/unmetered-gif.gif";
import mmLogo from "../../../assets/new-images/logo.png";
import logo1 from "../../../assets/new-images/logo-1.png";
import logo2 from "../../../assets/new-images/logo-2.png";
import logo3 from "../../../assets/new-images/logo-3.png";
import logo4 from "../../../assets/new-images/logo-4.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { animateScroll as scroll } from "react-scroll";
import { Link } from "react-router-dom";
import { Autoplay } from "swiper/modules";

const NewFooterUI = () => {
  const [loader, setLoader] = useState([]);
  const [openSection, setOpenSection] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  const [footerDestinations, setFooterDestinations] = useState([]);

  const fetchDestinations = async () => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    const formData = new FormData();
    formData.append("limit", 5);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: formData,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/destinations/fetch`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      setFooterDestinations(result?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchDestinations();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    handleResize(); // Call initially
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Toggle section only on mobile
  const toggleSection = (section) => {
    if (isMobile) {
      setOpenSection(openSection === section ? null : section);
    }
  };

  return (
    <footer>
      <div className={styles.footer}>
        <div className={styles.first_row}>
          {" "}
          <div className="container">
            <div className={styles.first_row_data}>
              <div className={styles.experience}>
                <h3>24/7</h3>
                <span>Support</span>
              </div>
              <div className={styles.experience}>
                <h3>150000+</h3>
                <span>Happy Clients</span>
              </div>
              <div className={styles.experience}>
                <h3>22+</h3>
                <span>Years of Experience</span>
              </div>
            </div>
            <div className={styles.first_row_data_mobile}>
              <Swiper
                loop={true}
                slidesPerView={1}
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                }}
                speed={500}
                modules={[Autoplay]}
                className="footer_support_section_slider"
              >
                <SwiperSlide>
                  <div className={styles.experience}>
                    <h3>24/7</h3>
                    <span>Support</span>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className={styles.experience}>
                    <h3>150000+</h3>
                    <span>Happy Clients</span>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className={styles.experience}>
                    <h3>22+</h3>
                    <span>Years of Experience</span>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
        <div className={styles.second_row}>
          <div className="container">
            <div className={styles.second_row_data}>
              <div className={styles.left_col}>
                <a href="/">
                  {" "}
                  <img
                    src={mmLogo}
                    alt="Logo"
                    style={{ height: "114px", width: "120px" }}
                  />
                </a>
              </div>
              <div className={styles.right_col}>
                <div className={styles.links}>
                  <h4
                    onClick={() => toggleSection("products")}
                    className={styles.accordionHeader}
                  >
                    Our Products
                    {isMobile && (
                      <span
                        className={
                          openSection === "products"
                            ? styles.arrowOpen
                            : styles.arrowClosed
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                        >
                          <mask
                            id="mask0_6537_60"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="16"
                            height="17"
                          >
                            <rect
                              y="16.0176"
                              width="16"
                              height="16"
                              transform="rotate(-90 0 16.0176)"
                              fill="#D9D9D9"
                            />
                          </mask>
                          <g mask="url(#mask0_6537_60)">
                            <path
                              d="M7.99976 9.89459L13.0216 4.87275C13.154 4.74031 13.31 4.67575 13.4894 4.67909C13.669 4.68253 13.825 4.75047 13.9574 4.88292C14.0899 5.01547 14.1561 5.17147 14.1561 5.35092C14.1561 5.53036 14.0899 5.68636 13.9574 5.81892L8.8536 10.9329C8.73304 11.0535 8.59799 11.1428 8.44843 11.2009C8.29888 11.259 8.14932 11.2881 7.99976 11.2881C7.85021 11.2881 7.70065 11.259 7.5511 11.2009C7.40154 11.1428 7.26649 11.0535 7.14593 10.9329L2.03177 5.81892C1.89932 5.68636 1.83482 5.52864 1.83827 5.34575C1.84171 5.16286 1.90965 5.0052 2.0421 4.87275C2.17454 4.74031 2.33054 4.67409 2.5101 4.67409C2.68954 4.67409 2.84549 4.74031 2.97793 4.87275L7.99976 9.89459Z"
                              fill="#1C1B1F"
                            />
                          </g>
                        </svg>
                      </span>
                    )}
                  </h4>
                  <div
                    className={`${styles.linksContent} ${isMobile && openSection === "products" ? styles.open : ""
                      }`}
                  >
                    <a href="/all-hotels">Hotels</a>
                    <a href="/all-packages">Holidays</a>
                    <a href="/all-activities">Activities</a>
                    <a href="/all-destinations">Destinations</a>
                    <a href="/themes">Themes</a>
                  </div>
                </div>
                <div className={styles.links}>
                  <h4
                    onClick={() => toggleSection("destinations")}
                    className={styles.accordionHeader}
                  >
                    POPULAR DESTINATIONS
                    {isMobile && (
                      <span
                        className={
                          openSection === "destinations"
                            ? styles.arrowOpen
                            : styles.arrowClosed
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                        >
                          <mask
                            id="mask0_6537_60"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="16"
                            height="17"
                          >
                            <rect
                              y="16.0176"
                              width="16"
                              height="16"
                              transform="rotate(-90 0 16.0176)"
                              fill="#D9D9D9"
                            />
                          </mask>
                          <g mask="url(#mask0_6537_60)">
                            <path
                              d="M7.99976 9.89459L13.0216 4.87275C13.154 4.74031 13.31 4.67575 13.4894 4.67909C13.669 4.68253 13.825 4.75047 13.9574 4.88292C14.0899 5.01547 14.1561 5.17147 14.1561 5.35092C14.1561 5.53036 14.0899 5.68636 13.9574 5.81892L8.8536 10.9329C8.73304 11.0535 8.59799 11.1428 8.44843 11.2009C8.29888 11.259 8.14932 11.2881 7.99976 11.2881C7.85021 11.2881 7.70065 11.259 7.5511 11.2009C7.40154 11.1428 7.26649 11.0535 7.14593 10.9329L2.03177 5.81892C1.89932 5.68636 1.83482 5.52864 1.83827 5.34575C1.84171 5.16286 1.90965 5.0052 2.0421 4.87275C2.17454 4.74031 2.33054 4.67409 2.5101 4.67409C2.68954 4.67409 2.84549 4.74031 2.97793 4.87275L7.99976 9.89459Z"
                              fill="#1C1B1F"
                            />
                          </g>
                        </svg>
                      </span>
                    )}
                  </h4>
                  <div
                    className={`${styles.linksContent} ${isMobile && openSection === "destinations"
                      ? styles.open
                      : ""
                      }`}
                  >
                    {footerDestinations &&
                      footerDestinations.length > 0 &&
                      footerDestinations.slice(0, 5)?.map((item) => (
                        <Link
                          onClick={() =>
                            scroll.scrollToTop({
                              duration: 500,
                              smooth: "easeInOutQuad",
                            })
                          }
                          className="single-des-link"
                          key={item.slug}
                          to={`/destination/${item.slug}`}
                        >
                          {item.name}
                        </Link>
                      ))}
                  </div>
                </div>
                <div className={styles.links}>
                  <h4
                    onClick={() => toggleSection("company")}
                    className={styles.accordionHeader}
                  >
                    Company
                    {isMobile && (
                      <span
                        className={
                          openSection === "company"
                            ? styles.arrowOpen
                            : styles.arrowClosed
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                        >
                          <mask
                            id="mask0_6537_60"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="16"
                            height="17"
                          >
                            <rect
                              y="16.0176"
                              width="16"
                              height="16"
                              transform="rotate(-90 0 16.0176)"
                              fill="#D9D9D9"
                            />
                          </mask>
                          <g mask="url(#mask0_6537_60)">
                            <path
                              d="M7.99976 9.89459L13.0216 4.87275C13.154 4.74031 13.31 4.67575 13.4894 4.67909C13.669 4.68253 13.825 4.75047 13.9574 4.88292C14.0899 5.01547 14.1561 5.17147 14.1561 5.35092C14.1561 5.53036 14.0899 5.68636 13.9574 5.81892L8.8536 10.9329C8.73304 11.0535 8.59799 11.1428 8.44843 11.2009C8.29888 11.259 8.14932 11.2881 7.99976 11.2881C7.85021 11.2881 7.70065 11.259 7.5511 11.2009C7.40154 11.1428 7.26649 11.0535 7.14593 10.9329L2.03177 5.81892C1.89932 5.68636 1.83482 5.52864 1.83827 5.34575C1.84171 5.16286 1.90965 5.0052 2.0421 4.87275C2.17454 4.74031 2.33054 4.67409 2.5101 4.67409C2.68954 4.67409 2.84549 4.74031 2.97793 4.87275L7.99976 9.89459Z"
                              fill="#1C1B1F"
                            />
                          </g>
                        </svg>
                      </span>
                    )}
                  </h4>
                  <div
                    className={`${styles.linksContent} ${isMobile && openSection === "company" ? styles.open : ""
                      }`}
                  >
                    <a href="/about">About us</a>
                    <a href="/contact-us">Contact us</a>
                    <a href="/health-safety">Health & Safety</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.third_row}>
          <div className="container">
            {" "}
            <div className={styles.third_row_data}>
              {" "}
              <span>Member of:</span>
              <div className={styles.members_images}>
                {" "}
                <img
                  src={logo1}
                  alt="Logo"
                  style={{ height: "55px", width: "55px" }}
                />
                <img
                  src={logo2}
                  alt="Logo"
                  style={{ height: "55px", width: "55px" }}
                />
                <img
                  src={logo3}
                  alt="Logo"
                  style={{ height: "45px", width: "75px" }}
                />
                <img
                  src={logo4}
                  alt="Logo"
                  style={{ height: "45px", width: "75px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.fifth_row}>
          <div className="container">
            <p>
              Disclaimer : All travel packages and services listed on this
              website are subject to availability and may change without prior
              notice. Prices, inclusions, and itineraries are not guaranteed
              until full payment is confirmed. The agency is not liable for any
              delays, cancellations, or issues caused by third-party providers
              or unforeseen events. We recommend travelers review all terms and
              conditions before booking. By using this site, you agree to comply
              with the policies stated.
            </p>
          </div>
        </div>
        <div className={styles.fourth_row}>
          <div className="container">
            {" "}
            <div className={styles.fourth_row_data}>
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/term-conditions">Terms & Conditions</a>
              <a href="/cancellation-policy">Cancellation Policy</a>
              <a href="/disclaimer">Disclaimer</a>
            </div>
          </div>
        </div>
        <div className={styles.sixth_row}>
          <div className="container">
            {" "}
            <div className={styles.sixth_row_data}>
              <span>© Copyright 2025. All Rights Reserved...</span>
              <div className={styles.social_links}>
                <a
                  href="https://www.facebook.com/mountainmysteries.in"
                  target="_blank"
                >
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12" stroke="#333333" />
                    <path
                      d="M13.75 13.4375H15.3125L15.9375 10.9375H13.75V9.6875C13.75 9.04375 13.75 8.4375 15 8.4375H15.9375V6.3375C15.7337 6.31063 14.9644 6.25 14.1519 6.25C12.455 6.25 11.25 7.28562 11.25 9.1875V10.9375H9.375V13.4375H11.25V18.75H13.75V13.4375Z"
                      fill="#333333"
                    />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/mountainmysteries/"
                  target="_blank"
                >
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12" stroke="#333333" />
                    <path
                      d="M9.875 6.25H15.125C17.125 6.25 18.75 7.875 18.75 9.875V15.125C18.75 16.0864 18.3681 17.0084 17.6883 17.6883C17.0084 18.3681 16.0864 18.75 15.125 18.75H9.875C7.875 18.75 6.25 17.125 6.25 15.125V9.875C6.25 8.91359 6.63192 7.99156 7.31174 7.31174C7.99156 6.63192 8.91359 6.25 9.875 6.25ZM9.75 7.5C9.15326 7.5 8.58097 7.73705 8.15901 8.15901C7.73705 8.58097 7.5 9.15326 7.5 9.75V15.25C7.5 16.4937 8.50625 17.5 9.75 17.5H15.25C15.8467 17.5 16.419 17.2629 16.841 16.841C17.2629 16.419 17.5 15.8467 17.5 15.25V9.75C17.5 8.50625 16.4937 7.5 15.25 7.5H9.75ZM15.7812 8.4375C15.9885 8.4375 16.1872 8.51981 16.3337 8.66632C16.4802 8.81284 16.5625 9.01155 16.5625 9.21875C16.5625 9.42595 16.4802 9.62466 16.3337 9.77118C16.1872 9.91769 15.9885 10 15.7812 10C15.574 10 15.3753 9.91769 15.2288 9.77118C15.0823 9.62466 15 9.42595 15 9.21875C15 9.01155 15.0823 8.81284 15.2288 8.66632C15.3753 8.51981 15.574 8.4375 15.7812 8.4375ZM12.5 9.375C13.3288 9.375 14.1237 9.70424 14.7097 10.2903C15.2958 10.8763 15.625 11.6712 15.625 12.5C15.625 13.3288 15.2958 14.1237 14.7097 14.7097C14.1237 15.2958 13.3288 15.625 12.5 15.625C11.6712 15.625 10.8763 15.2958 10.2903 14.7097C9.70424 14.1237 9.375 13.3288 9.375 12.5C9.375 11.6712 9.70424 10.8763 10.2903 10.2903C10.8763 9.70424 11.6712 9.375 12.5 9.375ZM12.5 10.625C12.0027 10.625 11.5258 10.8225 11.1742 11.1742C10.8225 11.5258 10.625 12.0027 10.625 12.5C10.625 12.9973 10.8225 13.4742 11.1742 13.8258C11.5258 14.1775 12.0027 14.375 12.5 14.375C12.9973 14.375 13.4742 14.1775 13.8258 13.8258C14.1775 13.4742 14.375 12.9973 14.375 12.5C14.375 12.0027 14.1775 11.5258 13.8258 11.1742C13.4742 10.8225 12.9973 10.625 12.5 10.625Z"
                      fill="#333333"
                    />
                  </svg>
                </a>
                {/* <div>
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12" stroke="#333333" />
                    <g clipPath="url(#clip0_5983_7125)">
                      <mask
                        id="mask0_5983_7125"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="7"
                        y="7"
                        width="12"
                        height="12"
                      >
                        <path d="M7 7H19V19H7V7Z" fill="white" />
                      </mask>
                      <g mask="url(#mask0_5983_7125)">
                        <path
                          d="M16.45 7.56226H18.2903L14.2703 12.1685L19 18.4377H15.2971L12.3949 14.6363L9.07771 18.4377H7.23571L11.5351 13.5091L7 7.56311H10.7971L13.4166 11.0371L16.45 7.56226ZM15.8029 17.3337H16.8229L10.24 8.60883H9.14629L15.8029 17.3337Z"
                          fill="#333333"
                        />
                      </g>
                    </g>
                    <defs>
                      <clipPath id="clip0_5983_7125">
                        <rect
                          width="12"
                          height="12"
                          fill="white"
                          transform="translate(7 7)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div> */}
                <a
                  href="https://www.youtube.com/channel/UCLCvoKy9UnH6f8nvax44R8w"
                  target="_blank"
                >
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12" stroke="#333333" />
                    <path
                      d="M17.2544 9.37187C17.2069 9.18562 17.0719 9.045 16.9175 9.00187C16.6438 8.925 15.3131 8.75 12.5006 8.75C9.68813 8.75 8.35813 8.925 8.0825 9.00187C7.93 9.04437 7.795 9.185 7.74688 9.37187C7.67875 9.63687 7.50062 10.7469 7.50062 12.5C7.50062 14.2525 7.67875 15.3625 7.74688 15.6287C7.79437 15.8144 7.92938 15.955 8.08313 15.9975C8.35812 16.075 9.6875 16.25 12.5 16.25C15.3125 16.25 16.6431 16.075 16.9181 15.9981C17.0706 15.9556 17.2056 15.815 17.2538 15.6281C17.3225 15.3631 17.5 14.25 17.5 12.5C17.5 10.75 17.3225 9.6375 17.2544 9.37187ZM18.4644 9.06125C18.75 10.175 18.75 12.5 18.75 12.5C18.75 12.5 18.75 14.825 18.4644 15.9388C18.3056 16.5544 17.8412 17.0387 17.2531 17.2025C16.1856 17.5 12.5 17.5 12.5 17.5C12.5 17.5 8.81687 17.5 7.74688 17.2025C7.15625 17.0363 6.6925 16.5525 6.53563 15.9388C6.25 14.825 6.25 12.5 6.25 12.5C6.25 12.5 6.25 10.175 6.53563 9.06125C6.69438 8.44563 7.15875 7.96125 7.74688 7.7975C8.8175 7.5 12.5006 7.5 12.5006 7.5C12.5006 7.5 16.1856 7.5 17.2538 7.7975C17.8438 7.96375 18.3081 8.4475 18.465 9.06125M11.2506 14.6875V10.3125L15.0006 12.5L11.2506 14.6875Z"
                      fill="#333333"
                    />
                  </svg>
                </a>
              </div>
              <span
                style={{ display: "flex", gap: "5px", alignItems: "center" }}
              >
                Powered by{" "}
                <a href="https://unmeteredtechnologies.com/" target="_blank">
                  {" "}
                  <img
                    src={unmeteredGif}
                    alt="unmetered-logo"
                    style={{ height: "auto", width: "75px" }}
                  />
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default NewFooterUI;
